import React from "react";
import { Route, Redirect } from "react-router-dom";

// https://stackoverflow.com/questions/48140299/reload-or-typing-url-manually-always-redirect-to-root

const isAuth = localStorage.getItem("token") == null ? false : true;

const renderMergedProps = (component, ...rest) => {
  const finalProps = Object.assign({}, ...rest);
  return React.createElement(component, finalProps);
};

const PrivateRoute = ({ component, redirectTo, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(routeProps) => {
        return isAuth ? (
          renderMergedProps(component, routeProps, rest)
        ) : (
          <Redirect
            to={{
              pathname: redirectTo,
              state: { from: routeProps.location },
            }}
          />
        );
      }}
    />
  );
};

export default PrivateRoute;
